export const REDIRECT_ERROR = 'redirect-failed';
export const MYCHART_UNAVAILABLE_ERROR_MESSAGE = 'mychart-unavailable';
export const INVALID_CONFIG_ERROR_MESSAGE = 'invalid-config';

export type MyChartRedirectFallbackMessage = typeof MYCHART_UNAVAILABLE_ERROR_MESSAGE | typeof INVALID_CONFIG_ERROR_MESSAGE;
